// extracted by mini-css-extract-plugin
export default {"wrapper":"modal-notification_wrapper__rqnB1","icon":"modal-notification_icon__YFroP","text":"modal-notification_text__KQxWy"};